import { render, staticRenderFns } from "./client-gnb.vue?vue&type=template&id=7b8a60c6&scoped=true&"
import script from "./client-gnb.vue?vue&type=script&lang=js&"
export * from "./client-gnb.vue?vue&type=script&lang=js&"
import style0 from "./client-gnb.vue?vue&type=style&index=0&id=7b8a60c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b8a60c6",
  null
  
)

export default component.exports